<template>
  <div class="move-inputwrap" :class="classes">
    <div v-if="label" class="label">
      <label>{{ label }}</label>
      <slot name="right"></slot>
    </div>
    <div class="input">
      <slot></slot>
    </div>
    <slot name="bottom"></slot>
  </div>
</template>
<script>
export default {
  name: 'MoveInputWrap',
  props: {
    size: {
      type: String,
      default: 'default',
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    classes() {
      return `move-inputwrap-${this.size}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.move-inputwrap {
  width: 100%;
  border-radius: 6px;
  &.move-inputwrap-large {
    .input {
      line-height: 36px;
      width: 100%;
    }
  }
  .input {
    line-height: 46px;
  }
  .label {
    .font-light;
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 300;
    color: @app-black-color;
  }
  &.move-inputwrap-large {
    .label {
      padding: 10px 0px;
    }
  }
}
</style>
<style lang="less">
@import '../../assets/css/main.less';
.move-inputwrap-error {
  .ivu-input {
    border: 1px solid @app-error-color;
  }
}
&.move-inputwrap-large {
  .ivu-input {
    height: 36px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 36px;
  }
}
</style>
